import React, { useEffect } from 'react';
import FlightsBackground from '../../../assets/images/flights/bg-flights.jpg';
import './style.scss';

const FlightsPage: React.FC = () => {
  useEffect(() => {
    // Load the Farebuzz script
    const script = document.createElement('script');
    script.src = 'https://www.farebuzz.com/MyTravel/101024/compressed.js';
    script.async = true;
    document.body.appendChild(script);

    // Initialize the widget after script loads
    script.onload = () => {
      (window as any).renderComponents([
        { 
          name: "Widget", 
          elementId: "searchWidget", 
          isTabEnable: true, 
          props: { isGCMS: true } 
        }
      ]);
    };

    // Cleanup function to remove script when component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []); // Empty dependency array means this effect runs once on mount

  return (
    <div className="flights-wrapper">
      <div className="flights-wrapper__header">
        <h1>Members Love Flying</h1>
        <h2>Find the best deals on flights. Compare airfares from top airlines, book one-way or round-trip tickets, and save big on your next trip. Fly smarter today!</h2>
      </div>
      <div className="flights-wrapper__search-form">
        <div className="flights-wrapper__search-form-content">
          <div id="searchWidget" className="flights-wrapper__search-widget"></div>
        </div>
      </div>
      <div className="flights-wrapper__background">
        <div className="flights-wrapper__content">
          <h3>Hundreds of amazing destinations</h3>
          <p>No matter where you need to go, we have the cheap tickets you need. If you have a meeting in London, Hong Kong, Paris or Rome, we'll make sure you get there in style - and without hurting your travel budget. On the other hand, if it's relaxation you're looking for, we have tons of cheap flights to Florida, Las Vegas, Hawaii and Mexico. You're just a few clicks away from scoring cheap airline tickets to your favorite destination.</p>
          
          <h3>Last-minute flights are no problem</h3>
          <p>Your travel plans can't always be scheduled months in advance. If you need a last-minute flight, we've got you covered. Cheap flights can be found at any time, not just weeks prior to departure. Our website and team of experts will help to ensure that your last-minute flight goes smoothly, so you can relax and focus on what's important.</p>
        </div>
      </div>
    </div>
  );
};

export default FlightsPage; 